import { combineReducers } from 'redux';
import authReducer from './authReducer';
import paramsReducer from './paramsReducer';
import siteReducer from './siteReducer';

export default combineReducers({
    auth: authReducer,
    params: paramsReducer,
    site: siteReducer
})